import { defineMessages } from 'react-intl';

export const messages: {
	showMore: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	showMore: {
		id: 'company-hub.help-object-search-component.show-more',
		defaultMessage: 'Show more',
		description: 'Navigates to the full search results page.',
	},
});
